import { ApiModule } from '@/api/api-module'
import routes from './routes'

export class ApiAccount extends ApiModule {
  getProfile() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.getProfile).then(response => {
        if (response.status === 200 && response.data) {
          resolve(response.data)
        } else {
          resolve(null)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

  updateProfile(profile = {}) {
    return new Promise((resolve, reject) => {
      this.http.patch(routes.updateProfile, profile).then( response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

  invites() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.invites).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  acceptInvite(data) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.acceptInvite, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  getSessions() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.getSessions).then(
        response => {
          if (response.status === 200 && response.data) {
            resolve(response.data)
          } else {
            reject('Error getting sessions')
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  signIn(email, password) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.signIn, {
          email_phone: email,
          email: email,
          password
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  signUp(email, password, confirm) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.signUp, {
          email_phone: email,
          password,
          password_confirm: confirm
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  }

  signOut() {
    return new Promise((resolve, reject) => {
      this.http.delete(routes.signOut).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  }

  signOutAll() {
    return new Promise((resolve, reject) => {
      this.http.delete(routes.signOutAll).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  signOutOne(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.signOutOne}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  changePassword(data) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.changePass, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  createCompany(data) {
    return new Promise((resolve, reject) => {
      this.http.put(routes.company, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  resendCode(data) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.resendCode, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  changeAuth(data) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.changeAuth, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  confirmAuth(data) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.confirmAuth, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  refreshToken(token) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.refresh, { refresh_token: token }).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getThemes(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.themes).then(
        response => {
          response.data.sort( (a, b) => {
            return (a.system === b.system) ? 0 : a.system ? -1 : 1;
          })
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createTheme(theme){
    return new Promise((resolve, reject) => {
      this.http.put(routes.themes, theme).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updateTheme(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.themes}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  selectTheme(id){
    return new Promise((resolve, reject) => {
      this.http.post(`${routes.themes}/${id}/select`, null).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  deleteTheme(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.themes}/${id}`, {headers: {'DMS-ACCOUNT-ID':'04a2e2a6-5c3e-41a7-932c-cb1c0be08121'}}).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  getRates() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.rate).then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(this.normalizeError(err))
      })
    })
  }

  getHistory() {
    return new Promise((resolve, reject) => {
      this.http.get(routes.history).then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(this.normalizeError(err))
      })
    })
  }

  paymentInit(order) {
    return new Promise((resolve, reject) => {
      this.http.post(routes.paymentInit, order).then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(this.normalizeError(err))
      })
    })
  }
  
  paymentDisable(id) {
    return new Promise((resolve, reject) => {
      this.http.post(`/payment/v1/${id}/autopay_cancel/`).then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(this.normalizeError(err))
      })
    })
  }
}

let apiAccount = new ApiAccount('account')

export default apiAccount

import httpClient from '@/api/http-client'
/**
 * Send message to support
 * @param {*} message
 */
export function sendToSupport(message) {
  return httpClient.http
    .post(routes.sendMessage, message)
    .then(response => {
      return response.data
    })
}



// WEBPACK FOOTER //
// ./src/apps/account/api/index.js